import $ from 'jquery';

class PageNav {
    constructor() {
        const handles = document.querySelectorAll('.js-page-nav');
        for (let i = 0; i < handles.length; i++) {
            handles[i].addEventListener('click', this.toggleNav);
        }
    }

    toggleNav(e) {
        e.preventDefault();
        const currentLabel = $(e.currentTarget).attr('aria-label')
        const target = e.currentTarget.parentNode;
        if(currentLabel === 'Öppna meny') {
            $(e.currentTarget).attr('aria-label', 'Stäng meny')
        } else {
            $(e.currentTarget).attr('aria-label', 'Öppna meny')
        }
        $(target)
            .next()
            .slideToggle('fast', () => {
                if (
                    $(target)
                        .next()
                        .is(':hidden')
                ) {
                    $(target).next().attr('aria-expanded', false);
                    $(target).addClass('page-nav__link--js-inactive');
                    $(target).removeClass('page-nav__link--js-active');
                } else {
                    $(target).next().attr('aria-expanded', true);
                    $(target).addClass('page-nav__link--js-active');
                    $(target).removeClass('page-nav__link--js-inactive');
                }
            });
    }
}

export default PageNav;
